// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestions-list__menu {
    text-align: left;
    color: black;
    display: flex;
    flex-direction: column;
    margin-left: -4.9rem !important;
    z-index: 10000;
    background-color: white;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
}

    .suggestions-list__menu.closing-suggestions {
        overflow-y: auto;
        max-height: 30rem;
        overflow-wrap: anywhere;
    overflow-x: hidden;
        max-width: 60%;
    }

.suggestions-list__tag-name {
    line-height: 1;
    margin: 0;
    color: black !important;
}

.suggestions-list__toggle {
    background: none; 
    border: none; 
    box-shadow: none;
    text-transform: none;
    font-size: 1rem;
    padding-top: 0px;
    cursor: inherit;
    margin-left: 5rem;
    width: 0 !important;
}

.suggestions-list__toggle:hover {
    background: none; 
    border: none; 
    box-shadow: none;
}

.suggestions-list__toggle:focus {
    background: none; 
}

.suggestions-list__suggestion {
    padding: 0.3rem 1.2rem 0.3rem 1.2rem;
    cursor: pointer;
    background: none;
    border: none;
    text-align: left;
    font-size: 1.8rem;
    line-height: 4rem;
}

.suggestions-list__suggestion:hover {
    background: #26a69a;
    color: #fff;
}

.tag-searching-input__container .dropdown {
    width: 0;
}

.suggestions-list__suggestion-operator {
    width: 100%;
    padding: 0.3rem 1.2rem 0.3rem 1.2rem;
    margin-right: auto;
    margin: auto 0;
    display: flex;
    font-size: 1.8rem;
    line-height: 4rem;
    cursor: pointer;
    background: none;
    border: none;
}

.suggestions-list__suggestion-operator:hover {
    background: #26a69a;
    color: #fff;
}

.suggestions-list__suggestion-operator .suggestion-operator__avatar {
    border-radius: 50%;
    margin: auto 0;
    margin-right: 1rem;
    box-shadow: 0px 0px 2px 1px #aaa;
    width: 30px;
    height: 30px;
}

.suggestions-list__suggestion-operator .suggestion-operator__avatar svg {
    width: 100% !important;
    height: 100% !important;
}

.suggestions-list__suggestion-operator .suggestion-contact__avatar {
    display: inline-block !important;
    border-radius: 50%;
    margin: auto 0;
    margin-right: 1rem;
    box-shadow: 0px 0px 2px 1px #aaa;
    width: 30px;
    height: 30px;
    }

.suggestions-list__suggestion-operator .suggestion-contact__avatar svg
{
    width: 100% !important;
    height: 100% !important;
}

.suggestion-operator__operator-info {
    display: flex;
    flex-direction: column;
    font-size: calc(1rem + 0.4vw);
    justify-content: center;
}

.suggestion-contact__contact-info {
    display: flex;
    flex-direction: column;
    font-size: calc(1rem + 0.4vw);
    justify-content: center;
}

.suggestion-contact__contact-phone {
    font-size: calc(0.8rem + 0.4vw);
}

.chat-tag-suggestion__dropdown {
    position: relative;
}

.chat-tag-suggestion__dropdown-list {
    position: absolute;
    left: 100%;
    top: 0;
    max-height: 20rem;
    overflow-y: auto;
    overflow-x: hidden;
    color: black;
    background-color: white;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
    width: max-content;
    max-width: 30rem;
    min-width: 12rem;
}

.chat-tag-suggestion__dropdown-item {
    width: 100%;
    max-width: 100%;
    padding: 0.3rem 1.2rem 0.3rem 1.2rem;
    display: block;
    font-size: 1.8rem;
    line-height: 4rem;
    cursor: pointer;
    background: none;
    border: none;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align:left;
}

.chat-tag-suggestion__dropdown-item:hover {
    background: #26a69a;
    color: #fff;
}

.chat-tag-suggestion__dropdown::after {
    display: inline-block;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    margin-right: 1rem;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid transparent;
    border-bottom: .3em solid transparent;
    border-left: .3em solid;
}

.splitter-layout .layout-pane:has(.chat-tag-suggestion__dropdown-list),
.chats-main.main-section:has(.chat-tag-suggestion__dropdown-list) {
    overflow: visible;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tag-searching-input/suggestions-list/SuggestionsList.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,+BAA+B;IAC/B,cAAc;IACd,uBAAuB;IACvB,uGAAuG;AAC3G;;IAEI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,uBAAuB;IAC3B,kBAAkB;QACd,cAAc;IAClB;;AAEJ;IACI,cAAc;IACd,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ;;AAEJ;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,uGAAuG;IACvG,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oCAAoC;IACpC,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;;IAEI,iBAAiB;AACrB","sourcesContent":[".suggestions-list__menu {\r\n    text-align: left;\r\n    color: black;\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-left: -4.9rem !important;\r\n    z-index: 10000;\r\n    background-color: white;\r\n    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);\r\n}\r\n\r\n    .suggestions-list__menu.closing-suggestions {\r\n        overflow-y: auto;\r\n        max-height: 30rem;\r\n        overflow-wrap: anywhere;\r\n    overflow-x: hidden;\r\n        max-width: 60%;\r\n    }\r\n\r\n.suggestions-list__tag-name {\r\n    line-height: 1;\r\n    margin: 0;\r\n    color: black !important;\r\n}\r\n\r\n.suggestions-list__toggle {\r\n    background: none; \r\n    border: none; \r\n    box-shadow: none;\r\n    text-transform: none;\r\n    font-size: 1rem;\r\n    padding-top: 0px;\r\n    cursor: inherit;\r\n    margin-left: 5rem;\r\n    width: 0 !important;\r\n}\r\n\r\n.suggestions-list__toggle:hover {\r\n    background: none; \r\n    border: none; \r\n    box-shadow: none;\r\n}\r\n\r\n.suggestions-list__toggle:focus {\r\n    background: none; \r\n}\r\n\r\n.suggestions-list__suggestion {\r\n    padding: 0.3rem 1.2rem 0.3rem 1.2rem;\r\n    cursor: pointer;\r\n    background: none;\r\n    border: none;\r\n    text-align: left;\r\n    font-size: 1.8rem;\r\n    line-height: 4rem;\r\n}\r\n\r\n.suggestions-list__suggestion:hover {\r\n    background: #26a69a;\r\n    color: #fff;\r\n}\r\n\r\n.tag-searching-input__container .dropdown {\r\n    width: 0;\r\n}\r\n\r\n.suggestions-list__suggestion-operator {\r\n    width: 100%;\r\n    padding: 0.3rem 1.2rem 0.3rem 1.2rem;\r\n    margin-right: auto;\r\n    margin: auto 0;\r\n    display: flex;\r\n    font-size: 1.8rem;\r\n    line-height: 4rem;\r\n    cursor: pointer;\r\n    background: none;\r\n    border: none;\r\n}\r\n\r\n.suggestions-list__suggestion-operator:hover {\r\n    background: #26a69a;\r\n    color: #fff;\r\n}\r\n\r\n.suggestions-list__suggestion-operator .suggestion-operator__avatar {\r\n    border-radius: 50%;\r\n    margin: auto 0;\r\n    margin-right: 1rem;\r\n    box-shadow: 0px 0px 2px 1px #aaa;\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n.suggestions-list__suggestion-operator .suggestion-operator__avatar svg {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.suggestions-list__suggestion-operator .suggestion-contact__avatar {\r\n    display: inline-block !important;\r\n    border-radius: 50%;\r\n    margin: auto 0;\r\n    margin-right: 1rem;\r\n    box-shadow: 0px 0px 2px 1px #aaa;\r\n    width: 30px;\r\n    height: 30px;\r\n    }\r\n\r\n.suggestions-list__suggestion-operator .suggestion-contact__avatar svg\r\n{\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.suggestion-operator__operator-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: calc(1rem + 0.4vw);\r\n    justify-content: center;\r\n}\r\n\r\n.suggestion-contact__contact-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: calc(1rem + 0.4vw);\r\n    justify-content: center;\r\n}\r\n\r\n.suggestion-contact__contact-phone {\r\n    font-size: calc(0.8rem + 0.4vw);\r\n}\r\n\r\n.chat-tag-suggestion__dropdown {\r\n    position: relative;\r\n}\r\n\r\n.chat-tag-suggestion__dropdown-list {\r\n    position: absolute;\r\n    left: 100%;\r\n    top: 0;\r\n    max-height: 20rem;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    color: black;\r\n    background-color: white;\r\n    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);\r\n    width: max-content;\r\n    max-width: 30rem;\r\n    min-width: 12rem;\r\n}\r\n\r\n.chat-tag-suggestion__dropdown-item {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    padding: 0.3rem 1.2rem 0.3rem 1.2rem;\r\n    display: block;\r\n    font-size: 1.8rem;\r\n    line-height: 4rem;\r\n    cursor: pointer;\r\n    background: none;\r\n    border: none;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    text-align:left;\r\n}\r\n\r\n.chat-tag-suggestion__dropdown-item:hover {\r\n    background: #26a69a;\r\n    color: #fff;\r\n}\r\n\r\n.chat-tag-suggestion__dropdown::after {\r\n    display: inline-block;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    width: 0;\r\n    height: 0;\r\n    margin-right: 1rem;\r\n    vertical-align: .255em;\r\n    content: \"\";\r\n    border-top: .3em solid transparent;\r\n    border-bottom: .3em solid transparent;\r\n    border-left: .3em solid;\r\n}\r\n\r\n.splitter-layout .layout-pane:has(.chat-tag-suggestion__dropdown-list),\r\n.chats-main.main-section:has(.chat-tag-suggestion__dropdown-list) {\r\n    overflow: visible;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
